import Vue from 'vue';

Vue.filter('nullable', function (model) {
  return model ? model : '-';
});
